'use strict';
import angular from 'angular';
import moment from 'moment';

export default class BadgeController {
  /*@ngInject*/
  constructor($stateParams, $location, $http, $state, $filter, $scope, Borne, appConfig, toastr, $rootScope) {
    var vm = this;
    var iterator = 0;
    vm.loading = true;
    vm.end = false;
    vm.first = true;
    vm.capturing = false;
    vm.clicked = false;
    vm.availableImages = ['jpg', 'png'];
    vm.availableVideos = ['mp3', 'mp4', 'mkv'];
    $('.modal-backdrop').hide();
    
    vm.zebra = (fs.existsSync('./resources/printer.txt' ) && fs.readFileSync('./resources/printer.txt', 'utf-8') == "ZEBRA");
    var video = document.getElementById('video');
    var canvas = document.getElementById('canvas');
    var context = canvas.getContext('2d');
    if(vm.zebra && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true }).then(function(stream) {
          setTimeout(function(){
            video.src = window.URL.createObjectURL(stream);
            video.play();
            vm.loading = false
            $scope.$apply()
            context.drawImage(video, 0, 0, 640, 480);
            vm.capture();
          }, 2000)
        });
    } else {
      vm.loading = false
    }

    if(!Borne.Poste) {
      Borne.load($stateParams.borneId).then(function () {
        initPage();
      	$scope.$apply();
      })
    } else {
      initPage();
    }

    function initPage() {
      vm.borne = Borne.Poste;
      vm.categorie = _.find(Borne.Poste.Categories, ['_id', $stateParams.id]);
      vm.categorieMessage = vm.categorie.traductions[vm.categorie.traductions.indexOf(_.find(vm.categorie.traductions, ['id', vm.borne.Langue.id]))].message;
      if(!Borne.Poste.Session.questions) {
        Borne.Poste.Session.questions = {};
        Borne.Poste.Session.questions.badAnwsers = [];
      };
      Borne.Poste.Session.questions.badAnwsers = $rootScope.badAnwsers;
      Borne.Poste.Session.category = {
        name : vm.categorie.name,
        _id : vm.categorie._id
      }
      Borne.Poste.Session.site = {
        _id : Borne.Poste.Site._id,
        name : Borne.Poste.Site.name
      }
      vm.formation = angular.copy(_.find(vm.categorie.Formations, ['active', true]));
      vm.borne.collecte.createdAt = moment(new Date).format('DD/MM/YYYY H:mm');
      vm.borne.collecte.expiryDate = moment().add(vm.categorie.expiryDate, 'd').format('DD/MM/YYYY H:mm');
      console.log(Borne.Poste.Session);
    }

    vm.capture = function() {
      if(!vm.capturing) {
        vm.otherCapture = false;
        vm.capturing = true;
        vm.timer = 5;
        var interval = setInterval(function(){
          if(vm.timer > 0) {
            vm.timer--;
            $scope.$apply();
          } else {
            clearInterval(interval);
            vm.otherCapture = true;
            context.drawImage(video, 0, 0, 296.250, 222.188);
            convertCanvasToImage(canvas);
            vm.capturing = false;
            $scope.$apply();
          }
        },1000)
      }
    }
    
    vm.openCategoryModal = function() {
      $('#categoryMessageModal').modal('show');
      vm.next();
    }

    vm.next = function() {
      if(vm.clicked == false) {
        vm.loading = true;
        vm.clicked = true;
        if(Borne.Poste.Session.badge){
          var badge = Borne.Poste.Session.badge;
          if(badge.active && badge.session.entrees) _.last(badge.session.entrees).sortie = new Date;
          if(!badge.session.entrees) badge.session.entrees = [{date : new Date}];
          else badge.session.entrees.push({date : new Date});
          badge.active = true;
          badge.exitTime = vm.categorie.autoEndTimer;
          $http.patch('/api/badges/' + badge._id, badge).then(function(resp){
            if(!vm.image) vm.image = "";
            var data = vm.image.replace(/^data:image\/\w+;base64,/, "");
            var imageBuffer = new Buffer(data, 'base64');
            var imgPath = basePath + '/resources/photos/'+resp.data._id+'.png';
            fs.writeFileSync(imgPath, imageBuffer);
            if(vm.zebra) {
              exec(basePath + '/resources/ZEBRA/ZEBRA_SDK.exe "'+imgPath+'" "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'"', {cwd : basePath + '/resources/ZEBRA/'},function(err, stdout, stdin){
                if(err) console.log(err);
                setTimeout(function(){
                  $('#categoryMessageModal').modal('hide');
                  vm.loading = false;
                  vm.borne.returnToMain();
                  $scope.$apply();
                },250)
              })
            } else {
              var imgPath = basePath + '/resources/logo.png';
              exec(basePath + '/resources/DYMO/DYMO.exe "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'" "'+imgPath+'"', {cwd : basePath + '/resources/DYMO/'},function(err, stdout, stdin){
                if(err) console.log(err);
                setTimeout(function(){
                  $('#categoryMessageModal').modal('hide');
                  vm.loading = false;
                  vm.borne.returnToMain();
                  $scope.$apply();
                },250)
              })
              /* exec('magick '+ imgPath +' -grayscale rec601luma -level 0%,60% '+ imgPath, function(err, stdout, stdin){
                exec(basePath + '/resources/DYMO/DYMO.exe "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'" "'+imgPath+'"', {cwd : basePath + '/resources/DYMO/'},function(err, stdout, stdin){
                  if(err) console.log(err);
                  setTimeout(function(){
                    $('#categoryMessageModal').modal('hide');
                    vm.loading = false;
                    vm.borne.returnToMain();
                    $scope.$apply();
                  },250)
                })
              }) */
            }
          })
        } else {
          var expiryDate = moment().add(vm.categorie.expiryDate, 'd').toDate();
          Borne.Poste.Session.entrees = [{date : new Date}];
          Borne.Poste.Session.langueId = Borne.Poste.Langue.id;
          $http.post('/api/badges', {name: vm.borne.collecte.Nom + ' ' + vm.borne.collecte.Prenom, exitTime : vm.categorie.autoEndTimer, session : Borne.Poste.Session, expiryDate : expiryDate, active:true, emails : _.map(Borne.Poste.Session.collecte.contacts, 'email'), online : $rootScope.qrcodeScanned}).then(function(resp){
            if(!vm.image) vm.image = "";
            var data = vm.image.replace(/^data:image\/\w+;base64,/, "");
            var imageBuffer = new Buffer(data, 'base64');
            var imgPath = basePath + '/resources/photos/'+resp.data._id+'.png';
            fs.writeFileSync(imgPath, imageBuffer);
            if(vm.zebra) {
              exec(basePath + '/resources/ZEBRA/ZEBRA_SDK.exe "'+imgPath+'" "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'"', {cwd : basePath + '/resources/ZEBRA/'},function(err, stdout, stdin){
                if(err) console.log(err);
                setTimeout(function(){
                  $('#categoryMessageModal').modal('hide');
                  vm.loading = false;
                  vm.borne.returnToMain();
                  $scope.$apply();
                },250)
              })
            } else {
              var imgPath = basePath + '/resources/logo.png';
              exec(basePath + '/resources/DYMO/DYMO.exe "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'" "'+imgPath+'"', {cwd : basePath + '/resources/DYMO/'},function(err, stdout, stdin){
                if(err) console.log(err);
                setTimeout(function(){
                  $('#categoryMessageModal').modal('hide');
                  vm.loading = false;
                  vm.borne.returnToMain();
                  $scope.$apply();
                },250)
              })
              /* exec('magick '+ imgPath +' -grayscale rec601luma -level 0%,60% '+ imgPath, function(err, stdout, stdin){
                exec(basePath + '/resources/DYMO/DYMO.exe "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'" "'+imgPath+'"', {cwd : basePath + '/resources/DYMO/'},function(err, stdout, stdin){
                  if(err) console.log(err);
                  setTimeout(function(){
                    $('#categoryMessageModal').modal('hide');
                    vm.loading = false;
                    vm.borne.returnToMain();
                    $scope.$apply();
                  },250)
                })
              }) */
            }
              /*exec(basePath + '/resources/DYMO/DYMO.exe "'+vm.borne.collecte.Nom+'" "'+vm.borne.collecte.Prenom+'" "'+vm.borne.collecte.Societe+'" "'+vm.borne.collecte.createdAt+'" "'+vm.borne.collecte.expiryDate+'" "'+$filter('dynamic')(vm.borne.Langue.dictionnary.badge.badge.mention,vm.categorie)+'" "'+resp.data._id.slice(0,8)+'" "'+imgPath+'"', {cwd : basePath + '/resources/DYMO/'},function(err, stdout, stdin){
                if(err) console.log(err);
                setTimeout(function(){
                  $('#categoryMessageModal').modal('hide');
                  vm.loading = false;
                  vm.borne.returnToMain();
                  $scope.$apply();
                },250)
              })*/
          })
        }
      }
    }

    function convertCanvasToImage(canvas) {
      var image = new Image();
      vm.image = canvas.toDataURL("image/png");
    }
  }
}


// WEBPACK FOOTER //
// ./client/app/borne/badge/badge.controller.js